import { useTheme } from 'next-themes';
import { Toaster as Sonner, toast } from 'sonner';

/**
 * Toaster de feedback de ação (salvou, desativou, erro).
 *
 * Montado uma vez em `src/app/providers.tsx`. Segue o tema do `next-themes` —
 * o app abre em dark por padrão, e um toast branco ali é agressão visual.
 *
 * ⚠️ `top-right`, e era `bottom-right` até o módulo de suporte existir. O
 * canto inferior direito passou a ser do `BotaoFlutuanteSuporte`
 * (`features/suporte`), e os dois disputando o mesmo lugar produziam o pior
 * caso possível: algo falha, o toast de erro nasce EM CIMA do botão, e quem
 * quer abrir um chamado por causa daquele erro clica no toast.
 *
 * Fica por cima do `<Header>` (que é `sticky top-0 z-30`) — o sonner tem
 * z-index próprio alto, e é o comportamento esperado de um toast.
 *
 * Não mova de volta sem tirar o botão flutuante antes.
 */
export function Toaster() {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={(theme as 'light' | 'dark' | 'system') ?? 'dark'}
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast bg-surface-raised text-foreground border-2 border-brand/20 shadow-lg',
          description: 'text-muted-foreground',
          actionButton: 'bg-brand text-brand-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
          error: 'border-destructive/40',
        },
      }}
    />
  );
}

export { toast };
